var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.liveList)?_c('ul',{staticClass:"live-list"},_vm._l((_vm.liveList),function(live,i){return _c('li',{key:i},[_c('live-card',_vm._b({},'live-card',live,false))],1)}),0):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }